import React, { useEffect, useRef } from "react";
import "./Sidebar.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { isAuthorized } from "../../utils/permissionUtils";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  const sidebarRef = useRef<HTMLDivElement | null>(null);

  // 権限
  const permissions = useSelector(
    (state: RootState) => state.user.userInfo?.permissions ?? []
  );

  useEffect(() => {
    const sidebarClose = (event: MouseEvent | KeyboardEvent) => {
      // サイドバーの位置とサイドバー内にクリックされているか、ハンバーガーメニューが押されているか
      if (event instanceof MouseEvent) {
        if (
          isOpen &&
          sidebarRef.current &&
          sidebarRef.current.getBoundingClientRect().left === 0 &&
          !sidebarRef.current.contains(event.target as Node)
        ) {
          setIsOpen(false); // サイドバーの外側がクリックされた場合にサイドバーを閉じる
        }
      } else if (event instanceof KeyboardEvent) {
        if (isOpen && event.key === "Escape") {
          setIsOpen(false); // ESCキーが押された場合にサイドバーを閉じる
        }
      }
    };

    if (isOpen) {
      // イベントリスナーの追加 クリックまたはキー押下されたらsidebarCloseが実行される
      document.addEventListener("click", sidebarClose);
      document.addEventListener("keydown", sidebarClose);

      return () => {
        // イベントリスナーの削除 「クリックされたらsidebarCloseを実行する」を削除する
        document.removeEventListener("click", sidebarClose);
        document.removeEventListener("keydown", sidebarClose);
      };
    }
  }, [isOpen, setIsOpen]);

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`} ref={sidebarRef}>
      <div>
        <div className="sb-menu-container">
          <h2>MENU</h2>
          <div className="sidebar-menu">
            <Link to="/">
              <img
                src="images/app-logo.png"
                width="40"
                height="40"
                alt="home"
              />
              <p>ホーム</p>
            </Link>
          </div>
          <div className="sidebar-menu">
            <Link to="/notifications">
              <img
                src="images/notifications-true.svg"
                width="40"
                height="40"
                alt="notifications"
              />
              <p>通知一覧</p>
            </Link>
          </div>
          <div className="sidebar-menu none">
            <img
              src="images/clock.svg"
              width="40"
              height="40"
              alt="notifications"
            />
            <p>修正</p>
          </div>
          <div className="sidebar-menu sub">
            {isAuthorized("1", permissions) && (
              <Link to="/machinerecords">
                <img
                  src="images/machine.svg"
                  width="24"
                  height="24"
                  alt="notifications"
                />
                <p>機械時間の修正</p>
              </Link>
            )}
          </div>
          <div className="sidebar-menu sub">
          {isAuthorized("2", permissions) && (
            <Link to="/workrecords">
              <img
                src="images/time-card.svg"
                width="24"
                height="24"
                alt="time-card"
              />
              <p>作業打刻の修正</p>
            </Link>
            )}
          </div>
          <div className="sidebar-menu">
            <Link to="/defectslist">
              <img
                src="images/defects.svg"
                alt="defectslist"
                className="icon background"
              />
              <p>不良一覧</p>
            </Link>
          </div>
          <p>稼働時刻修正</p>
          <p>人生産性</p>
          <p>稼働率</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
